import { Col, Row, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaAddressCard } from "react-icons/fa";
import { BsCreditCard2BackFill } from "react-icons/bs";
import { TbBuildingFactory } from "react-icons/tb";
import { useAxios } from "../../../context/AxiosProvider";
import { useValidation } from "../../../context/ValidationContext";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import axios from "axios";

const tehsils = [
  { id: 1, name: "Tehsil 1" },
  { id: 2, name: "Tehsil 2" },
  { id: 3, name: "Tehsil 3" },
  { id: 4, name: "Tehsil 4" },
];


const unionCouncils = [
  { id: 1, name: "Union Council 1" },
  { id: 2, name: "Union Council 2" },
  { id: 3, name: "Union Council 3" },
  { id: 4, name: "Union Council 4" },
];

export default function StoreBrickkiln({from,handleStoreModal}) {

  const { validateImageDimensions, validateCnic, formatCnic } = useValidation();
  const [searchValue, setSearchValue] = useState(""); // State for the input value
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  const [data, setData] = useState([]);
  const [brickkilnData, setBrickkilnData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [error, setError] = useState({});
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const axiosInstance = useAxios();


  // States to hold the file objects and their previews
  const [formState, setFormState] = useState({
    cnic_picture_front: { file: null, preview: null },
    cnic_picture_back: { file: null, preview: null },
    brickkiln_name:null,
    year_of_op:null,
    registered:null,
    brickkiln_owner:null,
    city_id:null,
    lat:null,
    long:null,
    owner_cnic:null,
    brickkiln_owner_cell:null,
    munshi_name:null,
    munshi_cnic:null,
    munshi_contact:null,
    address:null,
    union_council:null,
    union_council_number:0,
    tehsil:0,
    pin_location:null,
    brickkiln_name: null,
    owner_cnic: null,
    designation_id: 0,
    brick_kiln_pic: { file: null, preview: null },
  });

  //Handling cities Search
  // const handleSearch = (value) => {
  //   setSearchValue(value); // Update the input value
  //   if (value.trim() === "") {
  //     setFilteredCities([]); // Clear suggestions if input is empty
  //   } else {
  //     const filtered = data?.cities?.filter((city) =>
  //       city.name.toLowerCase().includes(value.toLowerCase())
  //     );
  //     setFilteredCities(filtered);
  //   }
  // };

  // Fetch initial data for designations and cities
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/common/brickkiln-initial-data"
        );
        setData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Handle file input change and validation
  const handleFileChange = async (e, fieldName, width, height) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Validate and resize the image
        const resizedImage = await validateImageDimensions(file, width, height);
        const previewUrl = URL.createObjectURL(resizedImage);

        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: {
            file: resizedImage,
            preview: previewUrl,
          },
        }));
        setError(""); // Clear any previous errors
      } catch (err) {
        setError("Invalid image file or dimensions.");
      }
    }
  };

  
  const handleChange = (e) => {
    const { name, value, type, files, } = e.target;
    let selectedOption = "";
    if (type === "select-one") { // Ensure it's a <select> element
      if (e.target.selectedIndex === -1 || value === "") {
        console.log("No option selected");
      } else {
        selectedOption = e.target.options[e.target.selectedIndex];
        console.log("Selected Option Value:", selectedOption.value);
        console.log("Selected Option InnerHTML:", selectedOption.innerHTML);
      }
    }
    // Handle file input
    if (type === "file") {
      const file = files[0];
      const previewUrl = file ? URL.createObjectURL(file) : null;

      setFormState((prevState) => ({
        ...prevState,
        [name]: {
          file,
          preview: previewUrl,
        },
      }));
    } else {
      // Handle regular input fields
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name === "designation_id" && value != "") {
      setDynamicTitle(selectedOption?.innerHTML);
      return;
    }

    // Handle CNIC field
    if (name === "owner_cnic") {
      const formattedCnic = formatCnic(value); // Format CNIC input
      setFormState((prevState) => ({
        ...prevState,
        owner_cnic: formattedCnic, // Update formatted CNIC in the form state
      }));

      // Validate CNIC
      setError((prevError) => ({
        ...prevError,
        owner_cnic: validateCnic(formattedCnic) ? "" : "Invalid CNIC", // Set error if CNIC is invalid
      }));
    }
  };

  // Handle form submission
 const handleSubmit = async (e) => {

  console.log("Submit clicked!");

  e.preventDefault();
  console.log("Submitted Brick Kiln Form:", formState);

  // const isValid = checkFields();
  // if (!isValid) return;
console.log("Submit clicked Again! ");

  setIsSubmitting(true);

  try {
    // Create FormData object
    const formData = new FormData();
    for (const key in formState) {
      const value = formState[key];
      formData.append(key, value?.file || value);
    }

    // Send API request
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/add-new-brickkiln`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${AuthToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("API Response:", response.data);
    alert("Brick kiln added successfully!");
        navigate("/all-brickkiln");

   
   

  } catch (err) {
    console.error("Error adding Brick Kiln:", err);
    alert("Something went wrong while adding Brick Kiln!");
  } finally {
    setIsSubmitting(false);
  }
};

  const checkFields = () => {
    const {
      cnic_picture_front,
      cnic_picture_back,
      brickkiln_name,
      year_of_op,
      registered,
      brickkiln_owner,
      owner_cnic,
      brickkiln_owner_cell,
      munshi_name,
      munshi_cnic,
      munshi_contact,
      address,
      union_council,
      union_council_number,
      tehsil,
      pin_location,
      designation_id,
      brick_kiln_pic,
    } = formState;

    const newError = {}; // Initialize an empty error object

    // Check for empty text fields and update error state


    if (!formState.brickkiln_name) {
      newError.brickkiln_name = "Brickkiln name is required.";
    }
    if (!formState.registered) {
      newError.registered = "Registration status is required.";
    }
    if (!formState.year_of_op) {
      newError.year_of_op = "Years of operations are required.";
    }
    if (!formState.brickkiln_owner) {
      newError.brickkiln_owner = "Owner name is required.";
    }
    if (!formState.owner_cnic) {
      newError.owner_cnic = "CNIC is required.";
    }
    if (!formState.brickkiln_owner_cell) {
      newError.brickkiln_owner_cell = "Owner contact number is required.";
    }
    if (!formState.munshi_name) {
      newError.munshi_name = "Munshi name is required.";
    }
    if (!formState.munshi_cnic) {
      newError.munshi_cnic = "Munshi CNIC is required.";
    }
    if (!formState.munshi_contact) {
      newError.munshi_contact = "Munshi contact number is required.";
    }
    if (!formState.address) {
      newError.address = "Brickkiln address is required.";
    }
    if (!formState.union_council) {
      newError.union_council = "Union council name is required.";
    }
    if (!formState.union_council_number) {
      newError.union_council_number = "Union council number is required.";
    }
   
    
    if (!brickkiln_name) {
      newError.brickkiln_name = "Brickkiln name is required.";
    }
    if (!owner_cnic) {
      newError.owner_cnic = "CNIC is required.";
    }
    if (!designation_id || designation_id === "") {
      newError.designation = "Designation is required.";
    }

    // Check for missing file uploads and update error state
    if (!cnic_picture_front.file) {
      newError.cnic_picture_front = "Please upload the CNIC Front Picture.";
    }
    if (!cnic_picture_back.file) {
      newError.cnic_picture_back = "Please upload the CNIC Back Picture.";
    }
    if (!brick_kiln_pic.file) {
      newError.brick_kiln_pic = "Please upload the Brick Kiln Picture.";
    }

    // If there are errors, update the error state and return false
    if (Object.keys(newError).length > 0) {
      setError((prevError) => ({
        ...prevError,
        ...newError, // Merge existing errors with new errors
      }));

      setTimeout(() => {
        setError({});
      }, 5000);
      return false;
    }

    // All validations passed, clear error state
    setError({});
    return true;
  };

  const storeData = async (formData) => {
    try {
      // Make the POST request
      const response = await axios.post(process.env.REACT_APP_API_URL+"/add-new-brickkiln", formData).then((res)=>{

 // Success handling
 Swal.fire({
    title: 'Success!',
    text: 'New Brick Kiln added successfully.',
    icon: 'success',
    confirmButtonText: 'Ok',
  });
  if(!from){
    navigate('/all-brickkiln')
  }else{
    handleStoreModal(res.data.brickkiln);
  }
      });

     
     
    } catch (error) {
      setIsSubmitting(false);
      // Validation error handling (status 422)
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        const errorList = Object.values(errors)
          .flat() // Flatten nested arrays
          .map((err) => `<li>${err}</li>`) // Convert each error into an HTML list item
          .join(''); // Join all list items

        Swal.fire({
          title: 'Please fix the following errors!',
          html: `<ul>${errorList}</ul>`,
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: {
            popup: 'text-left', // Align text to the left for better readability
          },
        });
      } else {
        // Generic error handling
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong. Please try again.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    }
  };


  const getDesignationID = (id) => {
    setFormState((prevState) => ({
      ...prevState,
      designation_id: id,
    }));
  };

  const handleRemoveImage = () => {
    setFormState((prevState) => ({
      ...prevState,
      brick_kiln_pic: {
        ...prevState.brick_kiln_pic,
        preview: null, // Reset preview image
      },
    }));
    // Optionally, you can also reset the file input to clear the file itself
    document.querySelector("input[name='brick_kiln_pic']").value = "";
  };

  return (
    <>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                <i className="material-icons">factory</i>
                Add New Brick Kiln
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="/" className="mc-breadcrumb-link"style={{color:"#077834"}}>
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">Add New Brick Kiln</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      <Row>


      <Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Name of Brick Kiln">
    <Form.Control
      type="text"
      placeholder="Name of Brick Kiln"
      required
      name="brickkiln_name"
      value={formState.brickkiln_name}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.brickkiln_name && (
    <div className="text-danger text-center">{error.brickkiln_name}</div>
  )}
</Form.Group>

<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Registration Status">
    <Form.Select
      required
      name="registered"
      value={formState.registered}
      onChange={handleChange}
    >
      <option value="">Select...</option>
      <option value="1">Registered</option>
      <option value="0">Unregistered</option>
    </Form.Select>
  </FloatingLabel>
  {error.registered && (
    <div className="text-danger text-center">{error.registered}</div>
  )}
</Form.Group>

<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Years of Operations">
    <Form.Control
      type="number"
      placeholder="Years of Operations"
      required
      name="year_of_op"
      value={formState.year_of_op}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.year_of_op && (
    <div className="text-danger text-center">{error.year_of_op}</div>
  )}
</Form.Group>


  <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Designation">
            <Form.Select
              required
              placeholder="Designation"
              name="designation_id"
              value={formState.designation_id}
              onChange={handleChange}
            >
              <option value={""}>Select...</option>
              {data?.designations?.map((designation) => (
                <option
                  key={designation.id}
                  value={designation.id}
                >
                  {designation.name}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
          {error.designation && (
            <div className="text-danger text-center">{error.designation}</div>
          )}
        </Form.Group>


{formState.designation_id === "1" && ( // assuming id 1 = Owner
  <>
    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Owner Name">
        <Form.Control
          type="text"
          placeholder="Owner Name"
          required
          name="brickkiln_owner"
          value={formState.brickkiln_owner}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.brickkiln_owner && (
        <div className="text-danger text-center">{error.brickkiln_owner}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Owner CNIC Number">
        <Form.Control
          type="text"
          placeholder="Owner CNIC Number"
          required
          name="owner_cnic"
          value={formState.owner_cnic}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.owner_cnic && (
        <div className="text-danger text-center">{error.owner_cnic}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Owner Contact Number">
        <Form.Control
          type="number"
          placeholder="Owner Contact Number"
          required
          name="brickkiln_owner_cell"
          value={formState.brickkiln_owner_cell}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.brickkiln_owner_cell && (
        <div className="text-danger text-center">{error.brickkiln_owner_cell}</div>
      )}
    </Form.Group>
  </>
)}

{formState.designation_id === "2" && ( 
  <>
    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Munshi Name">
        <Form.Control
          type="text"
          placeholder="Munshi Name"
          required
          name="munshi_name"
          value={formState.brickkiln_owner}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.brickkiln_owner && (
        <div className="text-danger text-center">{error.brickkiln_owner}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Munshi CNIC Number">
        <Form.Control
          type="number"
          placeholder="Munshi CNIC Number"
          required
          name="munshi_cnic"
          value={formState.owner_cnic}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.owner_cnic && (
        <div className="text-danger text-center">{error.owner_cnic}</div>
      )}
    </Form.Group>

    <Form.Group as={Col} md="4" className="mb-3">
      <FloatingLabel label="Munshi Contact Number">
        <Form.Control
          type="number"
          placeholder="Munshi Contact Number"
          required
          name="brickkiln owner cell"
          value={formState.brickkiln_owner_cell}
          onChange={handleChange}
        />
      </FloatingLabel>
      {error.brickkiln_owner_cell && (
        <div className="text-danger text-center">{error.brickkiln_owner_cell}</div>
      )}
    </Form.Group>
  </>
)}

<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Address of Brick Kiln">
    <Form.Control
      as="textarea"
      rows={4}
      placeholder="Plot Number or Village/Town/City"
      required
      name="address"
      value={formState.address}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.address && (
    <div className="text-danger text-center">{error.address}</div>
  )}
</Form.Group>

<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="union council">
    <Form.Control
      type="text"
      placeholder="union council"
      required
      name="union_council"
      value={formState.union_council}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.union_council && (
    <div className="text-danger text-center">{error.union_council}</div>
  )}
</Form.Group>

{/* <Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Union Council Number">
    <Form.Select
      required
      name="union_council_number"
      value={formState.union_council_number}
      onChange={handleChange}
    >
      <option value="">Select...</option>
      {unionCouncilNumbers.map((number) => (
        <option key={number.id} value={number.id}>
          {number.number}
        </option>
      ))}
    </Form.Select>
  </FloatingLabel>
  {error.union_council_number && (
    <div className="text-danger text-center">{error.union_council_number}</div>
  )}
</Form.Group> */}




<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="City">
    <Form.Select
      required
      name="city_id"
      value={formState.city_id}
      onChange={handleChange}
    >
      <option value="">Select</option>
      {data?.cities?.map((city) => (
        <option key={city.id} value={city.id}>
          {city.name}
        </option>
      ))}
    </Form.Select>
  </FloatingLabel>

  {error.city_id && (
    <div className="text-danger text-center">{error.city_id}</div>
  )}
</Form.Group>


<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Latitude">
    <Form.Control
      type="text"
      placeholder="latitude"
      required
      name="lat"
      value={formState.lat}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.lat && (
    <div className="text-danger text-center">{error.lat}</div>
  )}
</Form.Group>

<Form.Group as={Col} md="4" className="mb-3">
  <FloatingLabel label="Longitude">
    <Form.Control
      type="text"
      placeholder="longitude"
      required
      name="long"
      value={formState.long}
      onChange={handleChange}
    />
  </FloatingLabel>
  {error.long && (
    <div className="text-danger text-center">{error.long}</div>
  )}
</Form.Group>
       
        {/* <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Designation">
            <Form.Select
              required
              placeholder="Designation"
              name="designation_id"
              value={formState.designation_id}
              onChange={handleChange}
            >
              <option value={""}>Select...</option>
              {data?.designations?.map((designation) => (
                <option
                  key={designation.id}
                  value={designation.id}
                >
                  {designation.name}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
          {error.designation && (
            <div className="text-danger text-center">{error.designation}</div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="Brick Kiln Name">
            <Form.Control
              type="text"
              placeholder="Brick Kiln Name"
              required
              name="brickkiln_name"
              value={formState.brickkiln_name}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.brickkiln_name && (
            <div className="text-danger text-center">
              {error.brickkiln_name}
            </div>
          )}
        </Form.Group>


        <Form.Group as={Col} md="4" className="mb-3">
          <FloatingLabel label="CNIC">
            <Form.Control
              type="text"
              placeholder="CNIC"
              required
              name="owner_cnic"
              value={formState.owner_cnic}
              onChange={handleChange}
            />
          </FloatingLabel>
          {error.owner_cnic && (
            <div className="text-danger text-center">{error.owner_cnic}</div>
          )}
        </Form.Group> */}






        <Row>
          <Col xl={5}>
            <Col xl={12} style={{ cursor: "pointer" }}>
              <div className="mc-card" style={{ position: "relative" }}>
                <Form.Group>
                  <Form.Label
                    style={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {!formState.cnic_picture_front.preview ? (
                      <>
                        {"Add Brick Kilns Owner's CNIC Front"}
                        <i
                          style={{
                            color: "#077834",
                            cursor: "pointer",
                            fontSize: "4rem",
                          }}
                          className="material-icons"
                        >
                          <FaAddressCard />
                        </i>
                        <span
                          className="text-danger"
                          style={{
                            fontSize: "10px",
                            position: "absolute",
                            right: "15px",
                            bottom: "15px",
                          }}
                        >
                          Size Should be 500 x 200
                        </span>
                      </>
                    ) : (
                      <img
                        src={formState.cnic_picture_front.preview}
                        alt="CNIC Front Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          border: "2px solid #1976D2",
                          padding: "5px",
                        }}
                      />
                    )}
                    <Form.Control
                      type="file"
                      hidden
                      name="cnic_picture_front"
                      placeholder="Front Pic of CNIC"
                      onChange={(e) =>
                        handleFileChange(e, "cnic_picture_front", 500, 200)
                      }
                    />
                  </Form.Label>
                </Form.Group>
              </div>
              {error.cnic_picture_front && (
                <div className="text-danger text-center">
                  {error.cnic_picture_front}
                </div>
              )}
            </Col>

            <Col xl={12} style={{ cursor: "pointer" }}>
              <div className="mc-card" style={{ position: "relative" }}>
                <Form.Group>
                  <Form.Label
                    style={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {!formState.cnic_picture_back.preview ? (
                      <>
                        {"Add Back of CNIC"}
                        <i
                          style={{
                            color: "#077834",
                            cursor: "pointer",
                            fontSize: "4rem",
                          }}
                          className="material-icons"
                        >
                          <BsCreditCard2BackFill />
                        </i>
                        <span
                          className="text-danger"
                          style={{
                            fontSize: "10px",
                            position: "absolute",
                            right: "15px",
                            bottom: "15px",
                          }}
                        >
                          Size Should be 500 x 200
                        </span>
                      </>
                    ) : (
                      <img
                        src={formState.cnic_picture_back.preview}
                        alt="CNIC Back Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          border: "2px solid #1976D2",
                          padding: "5px",
                        }}
                      />
                    )}
                    <Form.Control
                      type="file"
                      hidden
                      name="cnic_picture_back"
                      placeholder="Back Pic of CNIC"
                      onChange={(e) =>
                        handleFileChange(e, "cnic_picture_back", 500, 200)
                      }
                    />
                  </Form.Label>
                </Form.Group>
              </div>
              {error.cnic_picture_back && (
                <div className="text-danger text-center">
                  {error.cnic_picture_back}
                </div>
              )}
            </Col>
          </Col>

          <Col xl={7}>
            <Form.Group as={Col} md="12" className="mb-3">
              <div
                className="mc-card"
                style={{
                  position: "relative",
                  overflow: "hidden",
                  height: "320px",
                  width: "550px",
                }}
              >
                <Form.Label
                  style={{
                    width: "100%",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {!formState.brick_kiln_pic.preview ? (
                    <>
                      {"Add Pic of Brick Kiln"}
                      <i
                        style={{
                          color: "#077834",
                          cursor: "pointer",
                          fontSize: "11rem",
                          textAlign: "center",
                        }}
                        className="material-icons"
                      >
                        <TbBuildingFactory />
                      </i>
                      <span
                        className="text-danger"
                        style={{
                          fontSize: "10px",
                          position: "absolute",
                          right: "15px",
                          bottom: "15px",
                        }}
                      >
                        Size Should be 500 x 270
                      </span>
                    </>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={formState.brick_kiln_pic.preview}
                        alt="Brick Kiln Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          border: "2px solid #1976D2",
                          padding: "5px",
                        }}
                      />
                      {/* <div
                        type="button"
                        onClick={handleRemoveImage}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          padding: "5px 8px",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </div> */}
                    </div>
                  )}
                  <Form.Control
                    type="file"
                    required
                    hidden
                    name="brick_kiln_pic"
                    placeholder="Add Brick Kiln Pic"
                    onChange={(e) =>
                      handleFileChange(e, "brick_kiln_pic", 500, 270)
                    }
                  />
                </Form.Label>
              </div>
              {error.brick_kiln_pic && (
                <div className="text-danger text-center">
                  {error.brick_kiln_pic}
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
        <Col xs={12} className="text-center mt-4">
  <Button
    variant="success"
    onClick={handleSubmit}
    disabled={isSubmitting}
  >
    {isSubmitting ? "Submitting..." : "Submit"}
  </Button>
</Col>

        </div>
      </Row>
    </>
  );
}
